import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13.5 3h-2.25v-.75A1.75 1.75 0 0 0 9.5.5h-3a1.75 1.75 0 0 0-1.75 1.75V3H2.5a.75.75 0 0 0 0 1.5h.25V13A1.25 1.25 0 0 0 4 14.25h8A1.25 1.25 0 0 0 13.25 13V4.5h.25a.75.75 0 1 0 0-1.5m-7.25-.75A.25.25 0 0 1 6.5 2h3a.25.25 0 0 1 .25.25V3h-3.5zm5.5 10.5h-7.5V4.5h7.5zM7.25 6.5v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0m3 0v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0"
	})
});
const Memo = memo(SvgTrash);
export default Memo;
